<template>
  <form
    class="is-flex is-centered"
    @submit.prevent="onSubmit"
  >
    <img
      src="../../../assets/img/secret-ciec.svg"
      alt="password illustration"
    >

    <div class="is-flex is-centered">
      <h1 class="title is-2 has-text-primary">
        Guardar CIEC
      </h1>

      <p class="content">
        Puedes agregar tu CIEC para sincronizar tus facturas con el SAT
        y poder gestionarlas deste tu portal de facturación favorito
        <span class="has-text-weight-bold has-text-primary">FACTURAV</span>.
      </p>

      <b-field>
        <b-input
          icon="archive"
          type="password"
          :value="ciec"
          :disabled="loading"
          :loading="loading"
          password-reveal
          @input="onChangeCIEC"
        />
      </b-field>

      <b-field>
        <b-button
          type="is-primary"
          native-type="submit"
          :disabled="loading || !ciec || ciec.length === 0"
          :loading="loading"
        >
          GUARDAR
        </b-button>
      </b-field>
    </div>
  </form>
</template>

<script>
import merge from 'lodash/merge';
import { createNamespacedHelpers } from 'vuex';

const { mapState, mapMutations } = createNamespacedHelpers('company');

export default {
  name: 'AddCIECForm',
  computed: mapState({
    ciec: ({ ciec }) => ciec,
    loading: ({ loading }) => loading,
  }),
  methods: merge(
    mapMutations(['setValue']),
    {
      onChangeCIEC(event) {
        this.setValue({ accessor: 'ciec', value: event });
      },
      onSubmit() {
        if (this.ciec) this.$emit('submit');
      },
    },
  ),
};
</script>

<style scoped>
img {
  width: 400px;
  height: auto;
}

p.content {
  max-width: 400px;
  text-align: justify;
}

form.is-flex.is-centered > .is-flex.is-centered {
  flex-direction: column;
}

@media screen and (max-width: 768px) {
  form.is-flex.is-centered {
    max-width: 300px;
    flex-wrap: wrap;
  }
}
</style>
